import * as React from 'react';
import NInput from "../NInput/NInput";
import {testChildString, testFormFieldValue} from "../../../../tests/test-data";


export const ParamFormGroupDefProps = {
  children: <NInput value={testFormFieldValue} onChange={()=>{}}/>,
  label: testChildString
};